import React from 'react';
import styled from 'styled-components';
import { Button, Container, Logo, Title } from '@components';
import avatar from './avatar.png';
import avatarRetina from './avatar@2x.png';

export interface NotificationProps {
  handleClick?: () => void;
}

const StyledContainer = styled(Container)`
  position: fixed;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.bg};
  z-index: 9999;
`;

const CustomLogo = styled(Logo)`
  position: fixed;
  top: 24px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;

const AvatarWrapper = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

const Avatar = styled.img`
  max-width: 100%;
  height: auto;
`;

const StyledTitle = styled(Title)`
  font-size: 24px;
  text-align: center;
  margin-bottom: 32px;
`;

const Notification: React.FC<NotificationProps> = ({ handleClick }) => (
  <StyledContainer align={'center'} fullHeight>
    <CustomLogo />
    <AvatarWrapper>
      <Avatar src={avatar} srcSet={`${avatarRetina} 2x`} alt={''} />
    </AvatarWrapper>
    <StyledTitle as={'h1'} level={'1'}>
      Чтобы пользоваться<br />
      редактором аватаров<br/>
      зайдите с компьютера
    </StyledTitle>
    <Button fullWidth onClick={ handleClick }>На главную</Button>
  </StyledContainer>
);

export { Notification };
